export default function objToUrlParam(obj) {
  let str = [];
  for (let param in obj)
    if (obj.hasOwnProperty(param)) {
      str.push(param + "=" + obj[param]);
    }
  return str.join("&");
}
